import { Channel } from '@/libraries/channel.ts';
import store from '@/store';

const channel = Channel.getInstance('ally');

export default {
	setList({ commit }: any, list: any) {
		commit('SET_LIST', list);
	},
	resetList({ commit }: any) {
		commit('RESET_LIST');
	},
	setDisplayList({ commit }: any, list: any) {
		commit('SET_DISPLAY_LIST', list);
	},
	resetDisplayList({ commit }: any) {
		commit('RESET_DISPLAY_LIST');
	},
	setInputText({ commit }: any, inputText: string) {
		commit('SET_INPUT_TEXT', inputText);
	},
	setAutoCompleteText({ commit }: any, autoCompleteText: string) {
		commit('SET_AUTO_COMPLETE_TEXT', autoCompleteText);
	},
	resetAutoCompleteText({ commit }: any) {
		commit('SET_AUTO_COMPLETE_TEXT', '');
	},
	async handleInput({ dispatch, commit, state, getters }: any) {
		if (getters.displayList.length > 0) {
			commit('UPDATE_CRUMBS', state.crumbs);
			commit('IS_LOADING');

			const nextState: any = await channel.emit({
				to: 'background',
				command: 'selectItem',
				args: [ getters.activeId ],
			});
			commit('DONE_LOADING');

			if (nextState.success) {
				dispatch('setState', [nextState.resp]);
			}
		} else if (state.launcherState === 'INPUT') { // background launcher model receives raw inputs
			const nextState: any = await channel.emit({
				to: 'background',
				command: 'handleRawInput',
				args: [ state.storeInputText ],
			});
			commit('DONE_LOADING');

			if (nextState.success) {
				dispatch('setState', [nextState.resp]);
			}
		}
		dispatch('focusOnInput');
	},
	setState({ commit, dispatch, state }: any, [nextState, keepInput]: any) {
		dispatch('setList', nextState.displayItems);
		commit('UPDATE_CRUMBS', nextState.crumbs);
		commit('UPDATE_PLACEHOLDER',  nextState.placeholder);
		commit('SET_LAUNCHER_STATE', nextState.state);

		if (!keepInput) {
			commit('SET_INPUT_TEXT', '');
		}

		if ('panel' in nextState && nextState.panel !== null) {
			commit('SET_DATA_PANEL_SIDE', nextState.panel);
		} else {
			commit('SET_DATA_PANEL_SIDE', '');
		}
		dispatch('updateActiveIdx', 0);
		dispatch('resetAutoCompleteText');
	},
	setDataPanelSide({ commit }: any, panel: string) {
		commit('SET_DATA_PANEL_SIDE', panel);
	},
	updateActiveId({}, id: number) {
		channel.emit({
			to: 'background',
			command: 'updateActiveIdx',
			args: [ id ],
		});
	},
	updateActiveIdx({ commit, state }: any, newIdx: number) {
		if (newIdx !== state.activeIdx) {
			commit('UPDATE_ACTIVE_IDX', newIdx);
		}
	},
	incrementActiveIdx({ dispatch, state }: any) {
		const newActiveIdx = state.activeIdx + 1;
		if (newActiveIdx >= state.displayListLength) {
			dispatch('updateActiveIdx', 0);
		} else {
			dispatch('updateActiveIdx', newActiveIdx);
		}
	},
	decrementActiveIdx({ dispatch, state }: any) {
		const newActiveIdx = state.activeIdx - 1;
		if (newActiveIdx < 0) {
			dispatch('updateActiveIdx', state.displayListLength - 1);
		} else {
			dispatch('updateActiveIdx', newActiveIdx);
		}
	},
	updateDisplayListLength({ commit, getters, state }: any, displayListLength: number) {
		commit('UPDATE_DISPLAY_LIST_LENGTH', displayListLength);

		if (getters.dataPanelOpen) { displayListLength = 4; }

		channel.emit({
			to: 'parent',
			command: 'update-ally-list-length',
			args: [ displayListLength ],
		});
	},
	async handleGoBack({ dispatch }: any) {
		const nextState: any = await channel.emit({
			to: 'background',
			command: 'backOneLevel',
		});
		dispatch('updateActiveIdx', 0);

		if (nextState.success) {
			dispatch('setState', [(nextState as any).resp]);
		}
	},
	async modifyExtractor({ dispatch, state }: any) {
		const nextState: any = await channel.emit({
			to: 'background',
			command: 'modifyAction',
			args: [store.getters.displayList[state.activeIdx].id]
		});

		if (nextState.success) {
			dispatch('setState', [nextState.resp]);
		}
	},
};
